import {BehaviorSubject} from "rxjs";
import {ProductCardColor} from "../interface/productCardColor";

export class ProductCard {
  //todo delete this class when organized "you may like it " section
  id: number | undefined;
  name: string = 'Product Name';
  pictureDefault: string = 'assets/homepage/premium-physical-cards/background.png';
  pictureHover: string = 'assets/all-products/hover-image.png';

  pictures: { path: string, isSelected: boolean }[] = [
    {path: 'assets/homepage/premium-physical-cards/background.png', isSelected: true},
    {path: 'assets/about-us/first.png', isSelected: false},
    {path: 'assets/homepage/premium-physical-cards/background.png', isSelected: false},
    {path: 'assets/homepage/premium-physical-cards/background.png', isSelected: false},
    {path: 'assets/homepage/premium-physical-cards/background.png', isSelected: false},
    {path: 'assets/homepage/premium-physical-cards/background.png', isSelected: false},
  ];

  price: number = 120;

  colors: ProductCardColor[] = [
    {id: 1, class: 'product-color first-product-color', isSelected: new BehaviorSubject(false)},
    {id: 2, class: 'product-color second-product-color mx-2', isSelected: new BehaviorSubject(false)},
    {id: 3, class: 'product-color third-product-color', isSelected: new BehaviorSubject(false)},
  ];

  isAddedToCart: boolean = false;
  description: string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In condimentum nisi lorem, ut congue metus efficitur id. Nunc id quam sed lectus bibendum sodales. Aenean in facilisis turpis, vel tempor velit.';
  quantity: number | undefined;

  compatibility: { firstPart: string, secondPart: string }[] = [
    {firstPart: 'Lorem ipsum', secondPart: '- dolor sit amet, consectetur adipiscing elit.'},
    {firstPart: 'Aliquam', secondPart: '- semper dolor eu aliquet cursus. Nulla sodales nisi purus.'},
    {firstPart: 'Condimentum', secondPart: '- nisi loremLorem ipsum dolor sit amet, consectetur adipiscing elit.'}
  ];

  constructor(id: number) {
    this.id = id;
  }
}
